export default __webpack_public_path__ + "static/media/november-card.ca8ff07a.png";